module.exports = __webpack_public_path__ + "images/syuccho_kaitori_lp/categories-title_efef6fa181580d52c6766661d89ad147.png";